module.exports = __webpack_public_path__ + "img/lg_ring_0_0_null_null@2x.2b59d6b0.png";